import BaseQuery from "@/stateManagement/BaseQuery";
import { filterNilValue } from "@datorama/akita";
import { singleton } from "tsyringe";

import type { RewardsQRCodeState } from "./RewardsQRCodeStore";
import RewardsQRCodeStore from "./RewardsQRCodeStore";

@singleton()
class RewardsQRCodeQuery extends BaseQuery<RewardsQRCodeState> {
    constructor(protected store: RewardsQRCodeStore) {
        super(store);
    }

    qrCode$ = this.select((state) => state.qrCode).pipe(filterNilValue());
    status$ = this.select((state) => state.status);
}

export default RewardsQRCodeQuery;
